/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddress
 */
export interface ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddress {
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddress
     */
    address_line_1_txt?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddress
     */
    address_line_2_txt?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddress
     */
    city_nm?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddress
     */
    state_abbreviation_cd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddress
     */
    zip_cd?: string;
}

/**
 * Check if a given object implements the ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddress interface.
 */
export function instanceOfExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddress(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddressFromJSON(json: any): ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddress {
    return ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddressFromJSONTyped(json, false);
}

export function ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddress {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'address_line_1_txt': !exists(json, 'address_line_1_txt') ? undefined : json['address_line_1_txt'],
        'address_line_2_txt': !exists(json, 'address_line_2_txt') ? undefined : json['address_line_2_txt'],
        'city_nm': !exists(json, 'city_nm') ? undefined : json['city_nm'],
        'state_abbreviation_cd': !exists(json, 'state_abbreviation_cd') ? undefined : json['state_abbreviation_cd'],
        'zip_cd': !exists(json, 'zip_cd') ? undefined : json['zip_cd'],
    };
}

export function ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddressToJSON(value?: ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddress | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'address_line_1_txt': value.address_line_1_txt,
        'address_line_2_txt': value.address_line_2_txt,
        'city_nm': value.city_nm,
        'state_abbreviation_cd': value.state_abbreviation_cd,
        'zip_cd': value.zip_cd,
    };
}

